import { ServiceConnectionMetadataModel } from '../../../api/api';
import useServiceConnectionMetadata from './useServiceConnectionMetadata';

export default function useServiceConnectionMetadataByName(name: string | undefined): ServiceConnectionMetadataModel | undefined {
	const { serviceConnectionByName } = useServiceConnectionMetadata();
	if (name) {
		return serviceConnectionByName.get(name);
	}
	return undefined;
}
